<div class="row">
    <div class="col-xl-6">

        <div class="card mb-3">
            <div class="card-header">
                <h5 class="card-header-title">
                    Bank Aggregation Token
                    <span style="float: right;" *ngIf="bankAggregationToken?.is_active">
                            <button
                                (click)="makeBankAggregationTokenized()"
                                title="Make bank aggregation tokenized"
                                type="button"
                                class="btn btn-accept"
                                style="font-size: 0.9rem; line-height: 0.7; padding: 0.375rem 0.40rem;"
                                [disabled]="bankAggregationTokenizedLoading"
                            >
                                Make Aggregation
                            </button>
                        </span>
                    <span style="float: right;" *ngIf="bankAggregationToken?.is_active">
                            <button
                                (click)="updateBankAggregationStatus()"
                                title="Make bank aggregation tokenized"
                                type="button"
                                class="btn btn-accept"
                                style="font-size: 0.9rem; line-height: 0.7; padding: 0.375rem 0.40rem;"
                            >
                                Update Status
                            </button>
                        </span>
                </h5>
            </div>
            <div class="card-body">
                <ul class="list-group">
                    <li
                        class="list-group-item d-flex justify-content-between align-items-center"
                    >
                        <strong [ngStyle]="{'color': bankAggregationToken?.is_active ? 'green' : 'red'}">
                            Actived
                        </strong>
                        <span class="text-right" [title]="bankAggregationToken?.is_active ? 'Actived' : 'Deactived'">
                            <i [ngClass]="bankAggregationToken?.is_active ? 'fa fa-check' : 'fa fa-close'">
                            </i>
                        </span>
                    </li>
                    <li
                        class="list-group-item d-flex justify-content-between align-items-center"
                    >
                        <strong>ID</strong
                        ><span class="text-right">{{ bankAggregationToken?.token_identifier }}</span>
                    </li>
                    <li
                        class="list-group-item d-flex justify-content-between align-items-center"
                    >
                        <strong>Num Failures</strong
                        ><span class="text-right">{{ bankAggregationToken?.num_failures }}</span>
                    </li>
                    <li
                        class="list-group-item d-flex justify-content-between align-items-center"
                    >
                        <strong>Last Used At</strong
                        ><span class="text-right">{{
                            bankAggregationToken?.last_status_at
                        }}</span>
                    </li>
                    <li
                        class="list-group-item d-flex justify-content-between align-items-center"
                    >
                        <strong>Created At</strong
                        ><span class="text-right">{{
                            bankAggregationToken?.provider_created_at
                        }}</span>
                    </li>
                    <li
                        class="list-group-item d-flex justify-content-between align-items-center"
                    >
                        <strong>Error Message</strong
                        ><span class="text-right">{{
                            bankAggregationToken?.error_message
                        }}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="card mb-3">
            <div class="card-header">
                <h5 class="card-header-title">Bank aggregation info</h5>
            </div>
            <div class="card-body">
                <ul class="list-group">
                    <li
                        class="list-group-item d-flex justify-content-between align-items-center"
                    >
                        <strong>Bank Name</strong
                        ><span class="text-right">{{
                            bankAggregation?.provider_bank_name
                        }}</span>
                    </li>
                    <li
                        class="list-group-item d-flex justify-content-between align-items-center"
                    >
                        <strong>Full name</strong
                        ><span class="text-right">{{
                            bankAggregation?.full_name
                        }}</span>
                    </li>
                    <li
                        class="list-group-item d-flex justify-content-between align-items-center"
                    >
                        <strong>Mobile Phone</strong
                        ><span class="text-right">{{ bankAggregation?.phone }}</span>
                    </li>
                    <li
                        class="list-group-item d-flex justify-content-between align-items-center"
                    >
                        <strong>Fix Phone</strong
                        ><span class="text-right">{{
                            bankAggregation?.fix_phone
                        }}</span>
                    </li>
                    <li
                        class="list-group-item d-flex justify-content-between align-items-center"
                    >
                        <strong>Personal ID</strong
                        ><span class="text-right">{{
                            bankAggregation?.personalid
                        }}</span>
                    </li>
                    <li
                        class="list-group-item d-flex justify-content-between align-items-center"
                    >
                        <strong>Birth Date</strong
                        ><span class="text-right">{{
                            bankAggregation?.birth_date
                        }}</span>
                    </li>
                    <li
                        class="list-group-item d-flex justify-content-between align-items-center"
                    >
                        <strong>Job Role</strong
                        ><span class="text-right">{{ bankAggregation?.job }}</span>
                    </li>
                    <li
                        class="list-group-item d-flex justify-content-between align-items-center"
                    >
                        <strong>Email</strong
                        ><span class="text-right">{{ bankAggregation?.email }}</span>
                    </li>
                    <li
                        class="list-group-item d-flex justify-content-between align-items-center"
                    >
                        <strong>Address</strong
                        ><span class="text-right">{{ bankAggregation?.address }}</span>
                    </li>
                    <li
                        class="list-group-item d-flex justify-content-between align-items-center"
                    >
                        <strong>Zip Code</strong
                        ><span class="text-right">{{ bankAggregation?.zip_code }}</span>
                    </li>
                    <li
                        class="list-group-item d-flex justify-content-between align-items-center"
                    >
                        <strong>City</strong
                        ><span class="text-right">{{ bankAggregation?.city }}</span>
                    </li>
                    <li
                        class="list-group-item d-flex justify-content-between align-items-center"
                    >
                        <strong>Town</strong
                        ><span class="text-right">{{ bankAggregation?.town }}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="col-xl-6">
        <div class="card mb-3">
            <div class="card-header" role="tab" id="headingCenterTwo">
                <h5 class="mb-0">
                    Bank Cards
                </h5>
            </div>
            <div
                id="collapseCenterTwo"
                class="collapse show"
                role="tabpanel"
                aria-labelledby="headingCenterTwo"
                data-parent="#accordion"
            >
                <div
                    class="card-body"
                    style="max-height: 230px; overflow: auto"
                >
                    <ul
                        class="list-group"
                        *ngFor="
                                let card of cards;
                                let index = index
                                let last = last
                            "
                    >
                        <li
                            class="
                                    list-group-item
                                    d-flex
                                    justify-content-between
                                    align-items-center
                                "
                        >
                            <strong>Name</strong
                            ><span>{{ card?.name }}</span>
                        </li>
                        <li
                            class="
                                    list-group-item
                                    d-flex
                                    justify-content-between
                                    align-items-center
                                "
                        >
                            <strong>Holder</strong
                            ><span class="text-right" [title]="card?.is_owner ? 'Yes' : 'No'">
                            <i [ngClass]="card?.is_owner ? 'fa fa-check' : 'fa fa-close'">
                            </i>
                        </span>
                        </li>
                        <li
                            class="
                                    list-group-item
                                    d-flex
                                    justify-content-between
                                    align-items-center
                                "
                        >
                            <strong>Holder Name</strong
                            ><span>{{ card?.holder_name }}</span>
                        </li>
                        <li
                            class="
                                    list-group-item
                                    d-flex
                                    justify-content-between
                                    align-items-center
                                "
                        >
                            <strong>Balance</strong
                            ><span>{{ card?.balance | currency: 'EUR' }}</span>
                        </li>
                        <li
                            class="
                                    list-group-item
                                    d-flex
                                    justify-content-between
                                    align-items-center
                                "
                        >
                            <strong>Credit Disposed</strong
                            ><span>{{ card?.credit_disposed | currency: 'EUR' }}</span>
                        </li>
                        <li
                            class="
                                    list-group-item
                                    d-flex
                                    justify-content-between
                                    align-items-center
                                "
                        >
                            <strong>Credit Limit</strong
                            ><span>{{ card?.credit_limit | currency: 'EUR' }}</span>
                        </li>
                        <li
                            class="
                                    list-group-item
                                    d-flex
                                    justify-content-between
                                    align-items-center
                                "
                        >
                            <strong>Card Status</strong>
                            <span>
                                <i [ngClass]="card?.active ? 'fa fa-unlock' : 'fa fa-lock'">
                                </i>
                                </span>
                        </li>
                        <li
                            class="
                                    list-group-item
                                    d-flex
                                    justify-content-between
                                    align-items-center
                                "
                        >
                            <strong>Last Number</strong>
                            <span>{{card?.last_number}}</span>
                        </li>
                        <li
                            class="
                                    list-group-item
                                    d-flex
                                    justify-content-between
                                    align-items-center
                                "
                        >
                            <strong>Expiration Month</strong
                            ><span>{{ card?.expiration_month }}</span>
                        </li>
                        <li
                            class="
                                    list-group-item
                                    d-flex
                                    justify-content-between
                                    align-items-center
                                "
                        >
                            <strong>Expiration Year</strong
                            ><span>{{ card?.expiration_year }}</span>
                        </li>
                        <li
                            class="
                                    list-group-item
                                    d-flex
                                    justify-content-between
                                    align-items-center
                                "
                        >
                            <strong>Card Type</strong
                            ><span>{{ card?.provider_type === '0' ? 'Debit' : 'Credit' }}</span>
                        </li>

                        <li
                            class="
                                    list-group-item
                                    d-flex
                                    justify-content-between
                                    align-items-center
                                "
                        >
                            <strong>Description</strong>
                            <span>{{card?.description || '-'}}</span>
                        </li>
                        <li *ngIf="!last" class="list-group-item p-0">
                            <hr style="border: none; height: 3px; background-color: #56365e; margin: 20px 0;" />
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-header">
                <h5 class="card-header-title">Bank Accounts</h5>
            </div>
            <div class="card-body">
                <div
                    *ngFor="let item of accounts; let last = last"
                    [ngClass]="{ 'mb-3': !last }"
                    class="row justify-content-beetwen"
                >
                    <div class="col">
                        <h6 class="mb-0">{{ item?.iban }} - {{item?.name}}</h6>
                        <small
                        >Holder:
                            <span class="text-right" [title]="item?.is_owner ? 'Yes' : 'No'">
                            <i [ngClass]="item?.is_owner ? 'fa fa-check' : 'fa fa-close'"></i>
                            </span>
                        </small
                        >
                        <br/>
                        <small
                        >Holder Name: {{ item?.holder_name }}
                        </small
                        >
                        <br/>
                        <small
                            >{{ item?.description }}({{ item?.code }}) /
                            Transactions:
                            {{ item?.transactions_count || '-' }}</small
                        >
                    </div>
                    <div class="col-auto">
                        {{ item?.balance | currency: item?.code }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class>
    <div class="card mb-3">
        <div class="card-header">
            <h5 class="card-header-title">BANK AGGREGATION REQUESTS</h5>
        </div>
        <div class="card-body">
            <div class="container-fluid">
                <div style="border-bottom: 3px solid #69356e">
                    <app-pager
                        [currentPage]="bankAggregationRequests?.current_page"
                        [firstPageUrl]="bankAggregationRequests?.first_page_url"
                        [from]="bankAggregationRequests?.from"
                        [lastPage]="bankAggregationRequests?.last_page"
                        [lastPageUrl]="bankAggregationRequests?.last_page_url"
                        [nextPageUrl]="bankAggregationRequests?.next_page_url"
                        [path]="bankAggregationRequests?.path"
                        [perPage]="bankAggregationRequests?.per_page"
                        [prev_page_url]="bankAggregationRequests?.prev_page_url"
                        [to]="bankAggregationRequests?.to"
                        [total]="bankAggregationRequests?.total"
                        (changePage)="getBankAggregationRequests($event)"
                    >
                    </app-pager>

                    <table class="table table-responsive">
                        <thead>
                        <tr>
                            <th width="8%">Created Date</th>
                            <th width="8%">Last Status Date</th>
                            <th width="14%">Identifier</th>
                            <th width="4%">Is Recurrent</th>
                            <th width="8%">Status</th>
                            <th width="20%">Provider Status</th>
                            <th width="38%">Description</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>
                                <input
                                    type="text"
                                    name="created_at"
                                    placeholder="Choose created date"
                                    daterangepicker
                                    value="{{ bankAggregationRequestDateInputValCreatedAt }}"
                                    [options]="options"
                                    (keyup.enter)="clearBankAggregationRequestFilter($event)"
                                    (selected)="
                                            selectedBankAggregationRequestDate(
                                                $event,
                                                'created_at'
                                            )
                                        "
                                />
                            </td>
                            <td>
                                <input
                                    type="text"
                                    name="last_status_at"
                                    placeholder="Choose last status date"
                                    daterangepicker
                                    value="{{ bankAggregationRequestDateInputValLastStatusAt }}"
                                    [options]="options"
                                    (keyup.enter)="clearBankAggregationRequestFilter($event)"
                                    (selected)="
                                            selectedBankAggregationRequestDate(
                                                $event,
                                                'last_status_at'
                                            )
                                        "
                                />
                            </td>
                            <td>
                                <input
                                    type="text"
                                    (keyup)="getBankAggregationRequestParamsFilter($event)"
                                    (keyup.enter)="makeBankAggregationRequestFilter()"
                                    placeholder="Identifier"
                                    name="identifier"
                                />
                            </td>
                            <td>
                                <select
                                    name="is_recurrent"
                                    (change)="
                                            getBankAggregationRequestParamsFilter($event);
                                            makeBankAggregationRequestFilter()
                                        "
                                >
                                    <option value="">Is Recurrent</option>
                                    <option
                                        *ngFor="let item of [{ name: 'Sí', value: 1 }, {name: 'No', value: 0}]"
                                        value="{{ item.value }}"
                                    >
                                        {{ item?.name }}
                                    </option>
                                </select>
                            </td>
                            <td>
                                <select
                                    name="status_id"
                                    (change)="
                                            getBankAggregationRequestParamsFilter($event);
                                            makeBankAggregationRequestFilter()
                                        "
                                >
                                    <option value="">Status</option>
                                    <option
                                        *ngFor="let status of bankAggregationRequestStatus"
                                        value="{{ status?.value }}"
                                    >
                                        {{ status?.name }}
                                    </option>
                                </select>
                            </td>
                            <td>
                            </td>
                            <td>
                            </td>
                        </tr>
                        <!-- Esto es para cuando se haga el filtrado se muestre solamente una file en la tabla con el  efecto loading ! -->
                        <!-- <tr *ngIf="loading">
                                            <img *ngIf="loading" width="50px" src="/assets/img/backoffice/loading.gif">
                                        </tr>
                                        ! -->

                        <tr
                            *ngFor="
                                    let request of bankAggregationRequests?.data
                                "
                        >
                            <td>{{ request?.created_at }}</td>
                            <td>{{ request?.last_status_at }}</td>
                            <td>
                                {{ request?.identifier }}
                            </td>
                            <td>{{ request?.is_recurrent ? 'Sí' : 'No' }}</td>
                            <td>{{ findStatusById(request?.status_id)?.name }}</td>
                            <td>{{ request?.provider_status }}</td>
                            <td>{{ request?.status_description }}</td>
                        </tr>
                        </tbody>
                    </table>

                    <app-pager
                        [currentPage]="bankAggregationRequests?.current_page"
                        [firstPageUrl]="bankAggregationRequests?.first_page_url"
                        [from]="bankAggregationRequests?.from"
                        [lastPage]="bankAggregationRequests?.last_page"
                        [lastPageUrl]="bankAggregationRequests?.last_page_url"
                        [nextPageUrl]="bankAggregationRequests?.next_page_url"
                        [path]="bankAggregationRequests?.path"
                        [perPage]="bankAggregationRequests?.per_page"
                        [prev_page_url]="bankAggregationRequests?.prev_page_url"
                        [to]="bankAggregationRequests?.to"
                        [total]="bankAggregationRequests?.total"
                        (changePage)="getBankAggregationRequests($event)"
                    >
                    </app-pager>
                </div>
            </div>
        </div>
    </div>
</div>

<div class>
    <div class="card mb-3">
        <div class="card-header">
            <h5 class="card-header-title">ACCOUNT TRANSACTIONS</h5>
        </div>
        <div class="card-body">
            <div class="container-fluid">
                <div style="border-bottom: 3px solid #69356e">
                    <app-pager
                        [currentPage]="bankTransaction?.current_page"
                        [firstPageUrl]="bankTransaction?.first_page_url"
                        [from]="bankTransaction?.from"
                        [lastPage]="bankTransaction?.last_page"
                        [lastPageUrl]="bankTransaction?.last_page_url"
                        [nextPageUrl]="bankTransaction?.next_page_url"
                        [path]="bankTransaction?.path"
                        [perPage]="bankTransaction?.per_page"
                        [prev_page_url]="bankTransaction?.prev_page_url"
                        [to]="bankTransaction?.to"
                        [total]="bankTransaction?.total"
                        (changePage)="getBankTransactions($event)"
                    >
                    </app-pager>

                    <table class="table table-responsive">
                        <thead>
                            <tr>
                                <th width="8%">Start Date</th>
                                <th width="8%">End Date</th>
                                <th width="6%">Currency Amount</th>
                                <th width="6%">Balance</th>
                                <th width="40%">Description</th>
                                <th width="12%">Iban</th>
                                <th width="20%">Category Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <!-- <input
                                        type="text"
                                        (keyup)="getParamsFilter($event)"
                                        (keyup.enter)="makeFilter()"
                                        placeholder="Start Date"
                                        name="start_date"
                                    > -->
                                    <input
                                        type="text"
                                        name="created_at_start"
                                        placeholder="Choose start date"
                                        daterangepicker
                                        value="{{ dateInputValStart }}"
                                        [options]="options"
                                        (keyup.enter)="clearFilter($event)"
                                        (selected)="
                                            selectedDate(
                                                $event,
                                                'created_at_start'
                                            )
                                        "
                                    />
                                </td>
                                <td>
                                    <!-- <input
                                        type="text"
                                        (keyup)="getParamsFilter($event)"
                                        (keyup)="getParamsFilter($event)"
                                        (keyup.enter)="makeFilter()"
                                        placeholder="End Date"
                                        name="end_date"
                                    > -->
                                    <input
                                        type="text"
                                        name="created_at_end"
                                        placeholder="Choose end date"
                                        daterangepicker
                                        value="{{ dateInputValEnd }}"
                                        [options]="options"
                                        (keyup.enter)="clearFilter($event)"
                                        (selected)="
                                            selectedDate(
                                                $event,
                                                'created_at_end'
                                            )
                                        "
                                    />
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        (keyup)="getParamsFilter($event)"
                                        (keyup)="getParamsFilter($event)"
                                        (keyup.enter)="makeFilter()"
                                        placeholder="Currency Amount"
                                        name="amount"
                                    />
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        (keyup)="getParamsFilter($event)"
                                        (keyup.enter)="makeFilter()"
                                        placeholder="New Balance"
                                        name="balance"
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        placeholder="description"
                                        name="description"
                                        (keyup)="getParamsFilter($event)"
                                        (keyup.enter)="makeFilter()"
                                    />
                                </td>
                                <td>
                                    <select
                                        name="iban"
                                        *ngIf="accounts?.length"
                                        (change)="
                                            getParamsFilter($event);
                                            makeFilter()
                                        "
                                    >
                                        <option value="">Select IBAN</option>
                                        <option
                                            *ngFor="let item of accounts"
                                            value="{{ item.iban }}"
                                        >
                                            {{ item?.iban }}{{item?.is_owner ? ' (Holder)' : ''}}
                                        </option>
                                    </select>
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        placeholder="Category Name"
                                        name="provider_category_name"
                                        (keyup)="getParamsFilter($event)"
                                        (keyup.enter)="makeFilter()"
                                    />
                                </td>
                            </tr>
                            <!-- Esto es para cuando se haga el filtrado se muestre solamente una file en la tabla con el  efecto loading ! -->
                            <!-- <tr *ngIf="loading">
                                                <img *ngIf="loading" width="50px" src="/assets/img/backoffice/loading.gif">
                                            </tr>
                                            ! -->

                            <tr
                                *ngFor="
                                    let transaction of bankTransaction?.data
                                "
                            >
                                <td>{{ transaction?.start_date }}</td>
                                <td>{{ transaction?.end_date }}</td>
                                <td>
                                    {{ transaction?.amount | currency: 'EUR' }}
                                </td>
                                <td>
                                    {{ transaction?.balance | currency: 'EUR' }}
                                </td>
                                <td>{{ transaction?.description }}</td>
                                <td>{{ transaction?.iban }}{{transaction?.is_owner ? ' (Holder)' : ''}}</td>
                                <td>{{ transaction?.provider_category_name }}</td>
                            </tr>
                        </tbody>
                    </table>

                    <app-pager
                        [currentPage]="bankTransaction?.current_page"
                        [firstPageUrl]="bankTransaction?.first_page_url"
                        [from]="bankTransaction?.from"
                        [lastPage]="bankTransaction?.last_page"
                        [lastPageUrl]="bankTransaction?.last_page_url"
                        [nextPageUrl]="bankTransaction?.next_page_url"
                        [path]="bankTransaction?.path"
                        [perPage]="bankTransaction?.per_page"
                        [prev_page_url]="bankTransaction?.prev_page_url"
                        [to]="bankTransaction?.to"
                        [total]="bankTransaction?.total"
                        (changePage)="getBankTransactions($event)"
                    >
                    </app-pager>
                </div>
            </div>
        </div>
    </div>
</div>

<div class>
    <div class="card mb-3">
        <div class="card-header">
            <h5 class="card-header-title">CARD TRANSACTIONS</h5>
        </div>
        <div class="card-body">
            <div class="container-fluid">
                <div style="border-bottom: 3px solid #69356e">
                    <app-pager
                        [currentPage]="bankCardTransaction?.current_page"
                        [firstPageUrl]="bankCardTransaction?.first_page_url"
                        [from]="bankCardTransaction?.from"
                        [lastPage]="bankCardTransaction?.last_page"
                        [lastPageUrl]="bankCardTransaction?.last_page_url"
                        [nextPageUrl]="bankCardTransaction?.next_page_url"
                        [path]="bankCardTransaction?.path"
                        [perPage]="bankCardTransaction?.per_page"
                        [prev_page_url]="bankCardTransaction?.prev_page_url"
                        [to]="bankCardTransaction?.to"
                        [total]="bankCardTransaction?.total"
                        (changePage)="getBankCardTransactions($event)"
                    >
                    </app-pager>

                    <table class="table table-responsive">
                        <thead>
                        <tr>
                            <th width="8%">Start Date</th>
                            <th width="8%">End Date</th>
                            <th width="6%">Currency Amount</th>
                            <th width="40%">Description</th>
                            <th width="12%">Name</th>
                            <th width="20%">Category Name</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>
                                <!-- <input
                                    type="text"
                                    (keyup)="getParamsFilter($event)"
                                    (keyup.enter)="makeFilter()"
                                    placeholder="Start Date"
                                    name="start_date"
                                > -->
                                <input
                                    type="text"
                                    name="start_date"
                                    placeholder="Choose start date"
                                    daterangepicker
                                    value="{{ cardTransactionDateInputValStart }}"
                                    [options]="options"
                                    (keyup.enter)="clearCardTransactionFilter($event)"
                                    (selected)="
                                            selectedCardTransactionDate(
                                                $event,
                                                'start_date'
                                            )
                                        "
                                />
                            </td>
                            <td>
                                <!-- <input
                                    type="text"
                                    (keyup)="getParamsFilter($event)"
                                    (keyup)="getParamsFilter($event)"
                                    (keyup.enter)="makeFilter()"
                                    placeholder="End Date"
                                    name="end_date"
                                > -->
                                <input
                                    type="text"
                                    name="end_date"
                                    placeholder="Choose end date"
                                    daterangepicker
                                    value="{{ cardTransactionDateInputValEnd }}"
                                    [options]="options"
                                    (keyup.enter)="clearCardTransactionFilter($event)"
                                    (selected)="
                                            selectedCardTransactionDate(
                                                $event,
                                                'end_date'
                                            )
                                        "
                                />
                            </td>
                            <td>
                                <input
                                    type="number"
                                    (keyup)="getCardTransactionParamsFilter($event)"
                                    (keyup)="getCardTransactionParamsFilter($event)"
                                    (keyup.enter)="makeCardTransactionFilter()"
                                    placeholder="Currency Amount"
                                    name="amount"
                                />
                            </td>
                            <td>
                                <input
                                    type="text"
                                    placeholder="description"
                                    name="description"
                                    (keyup)="getCardTransactionParamsFilter($event)"
                                    (keyup.enter)="makeCardTransactionFilter()"
                                />
                            </td>
                            <td>
                                <select
                                    name="id"
                                    *ngIf="cards?.length"
                                    (change)="
                                            getCardTransactionParamsFilter($event);
                                            makeCardTransactionFilter()
                                        "
                                >
                                    <option value="">Select Card</option>
                                    <option
                                        *ngFor="let item of cards"
                                        value="{{ item.id }}"
                                    >
                                        {{ item.name }} - {{ item.last_number }}{{item?.is_owner ? ' (Holder)' : ''}}
                                    </option>
                                </select>
                            </td>
                            <td>
                                <input
                                    type="text"
                                    placeholder="Category Name"
                                    name="provider_category_name"
                                    (keyup)="getCardTransactionParamsFilter($event)"
                                    (keyup.enter)="makeCardTransactionFilter()"
                                />
                            </td>
                        </tr>
                        <!-- Esto es para cuando se haga el filtrado se muestre solamente una file en la tabla con el  efecto loading ! -->
                        <!-- <tr *ngIf="loading">
                                            <img *ngIf="loading" width="50px" src="/assets/img/backoffice/loading.gif">
                                        </tr>
                                        ! -->

                        <tr
                            *ngFor="
                                    let transaction of bankCardTransaction?.data
                                "
                        >
                            <td>{{ transaction?.start_date }}</td>
                            <td>{{ transaction?.end_date }}</td>
                            <td>
                                {{ transaction?.amount | currency: 'EUR' }}
                            </td>
                            <td>{{ transaction?.description }}</td>
                            <td>{{ transaction.name }} - {{ transaction.last_number }}{{transaction?.is_owner ? ' (Holder)' : ''}}</td>
                            <td>{{ transaction.provider_category_name }}</td>
                        </tr>
                        </tbody>
                    </table>

                    <app-pager
                        [currentPage]="bankCardTransaction?.current_page"
                        [firstPageUrl]="bankCardTransaction?.first_page_url"
                        [from]="bankCardTransaction?.from"
                        [lastPage]="bankCardTransaction?.last_page"
                        [lastPageUrl]="bankCardTransaction?.last_page_url"
                        [nextPageUrl]="bankCardTransaction?.next_page_url"
                        [path]="bankCardTransaction?.path"
                        [perPage]="bankCardTransaction?.per_page"
                        [prev_page_url]="bankCardTransaction?.prev_page_url"
                        [to]="bankCardTransaction?.to"
                        [total]="bankCardTransaction?.total"
                        (changePage)="getBankCardTransactions($event)"
                    >
                    </app-pager>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- scoring tab page -->
